import Swal from 'sweetalert2'
import moment from 'moment'
import router from '@/router'
import store from '@/store/vuex'

const images = import.meta.glob('/src/assets/**/*.{png,jpg,jpeg,svg,gif,webp,avif}', {
  eager: true,
  import: 'default',
})

//#region SWAL
export default {
  ToastNotify(Type, Title, Timer) {
    if (!Timer) Timer = 1000
    Swal.fire({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: Timer,
      timerProgressBar: true,
      icon: Type,
      title: Title,
    })
  },
  ToastNotifySomethingWentWrong(Timer) {
    if (!Timer) Timer = 1500
    Swal.fire({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: Timer,
      timerProgressBar: true,
      icon: 'error',
      title: store.state.notFoundToast,
    })
  },
  replacePlaceholders(template, data) {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
      return data[key] ?? ''
    })
  },

  //#endregion

  //#region Images

  GetImageDynamicPath(item) {
    return new URL(item, import.meta.url).href
  },

  ShowDynamicPathImage(imagePath, defaultImg = '@/assets/images/default.png') {
    const p = (imagePath || defaultImg).trim()

    const key = p.startsWith('@/assets/') ? `/src/assets/${p.replace('@/assets/', '')}` : p

    return images[key] || ''
  },

  ShowDynamicImage(imagePath, defaultImg) {
    if (!imagePath) {
      const defaultimg = `images/${defaultImg}.png`
      return new URL(`/src/assets/images/${defaultImg}.png`, import.meta.url).href
    }
    return imagePath
  },

  ShowDynamicImageSvg(imagePath, defaultImg) {
    if (!imagePath) {
      const defaultimg = `images/${defaultImg}.svg`
      return new URL(`../assets/images/${defaultImg}.svg`, import.meta.url).href
      // return new URL(`/src/assets/${defaultimg}`, import.meta.url).href;
    }
    return imagePath
  },

  //#endregion

  //#region Date
  FormatDateDMY(date) {
    return moment(date).format('DD.MM.YYYY')
  },

  //#endregion

  TextLimiter(text, charactersLimit, defaultString) {
    if (text) {
      return text.length > charactersLimit ? text.substring(0, charactersLimit) + '...' : text
    } else {
      return defaultString
    }
  },

  GetLangFromRoute() {
    const { currentRoute } = router
    const lang = currentRoute.value?.params?.lang || 'ro'
    return lang
  },

  GetCompanySizes() {
    return [
      {
        value: 'Micro (1–9)',
        ro: 'Micro (1–9)',
        en: 'Micro (1–9)',
      },
      {
        value: 'Small (10–49)',
        ro: 'Mică (10–49)',
        en: 'Small (10–49)',
      },
      {
        value: 'Medium (50–249)',
        ro: 'Medie (50–249)',
        en: 'Medium (50–249)',
      },
      {
        value: 'Large (250+)',
        ro: 'Mare (250+)',
        en: 'Large (250+)',
      },
    ]
  },
  //#region Squidex
  getCookie() {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith('languageCode='))
      ?.split('=')[1]
  },
  replacePlaceholders(template, data) {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
      return data[key] ?? ''
    })
  },
  removeLocaleDeep(obj, lang) {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.removeLocaleDeep(item, lang))
    }

    if (obj && typeof obj === 'object') {
      const keys = Object.keys(obj)
      if (keys.length === 1 && keys[0] === lang) {
        return this.removeLocaleDeep(obj[lang], lang)
      }

      if (keys.length === 1 && keys[0] === 'iv') {
        return this.removeLocaleDeep(obj.iv, lang)
      }

      const result = {}

      for (const key in obj) {
        result[key] = this.removeLocaleDeep(obj[key], lang)
      }

      return result
    }

    return obj
  },
  setAssetUrl(id) {
    const baseUrl = import.meta.env.VITE_BASE_URL
    const test = window.location.origin
    const val = `${test}${baseUrl}api/Squidex/getAsset?assetCode=${id}`
    return val
  },

  isImageField(key) {
    return key.toLowerCase().includes('image')
  },

  getImageUrl(value) {
    if (!value) return null

    let asset = null

    if (Array.isArray(value)) {
      asset = value[0]
    } else if (value.iv && Array.isArray(value.iv)) {
      asset = value.iv[0]
    }

    if (!asset?.id) return null

    return this.setAssetUrl(asset.id)
  },

  transformImageFields(obj) {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.transformImageFields(item))
    }

    if (obj && typeof obj === 'object') {
      const result = {}

      for (const key in obj) {
        const value = obj[key]

        if (this.isImageField(key)) {
          result[key] = this.getImageUrl(value)
        } else {
          result[key] = this.transformImageFields(value)
        }
      }

      return result
    }

    return obj
  },
  //#endRegion
}
